import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuditHistoryService } from '../../../../../../../../../../core/services/audit-history.service';
import { SolutionEstimation, solutionEstimateDBKeys, solutionEstimateKeys } from '../../../../../../../utils';

@Component({
  selector: 'app-solution-description-audit-log',
  templateUrl: './solution-description-audit-log.component.html',
  styleUrls: ['./solution-description-audit-log.component.scss']
})
export class SolutionDescriptionAuditLogComponent implements OnInit {
  auditLoader = true;
  auditLogData: any = [];
  solutionEstimateDBKeys =solutionEstimateDBKeys
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<SolutionDescriptionAuditLogComponent>,
    public auditHistoryService: AuditHistoryService,
  ) { }

  ngOnInit() {
    this.fetchAuditLogs();
  }

  fetchAuditLogs() {
    this.auditHistoryService.fetchLogs(SolutionEstimation).then((auditLogRes: any) => {

      this.auditHistoryService.formatAuditLogData(auditLogRes).then((formatRes) => {
        this.auditLogData = formatRes;
        this.auditLoader = false;
      })

    }).catch((auditLogErr) => {
      this.auditLoader = false;
    });
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-audit-log/solution-description-audit-log.component.ts